import React from 'react';
import ImgIconComp from '../imgcomp';

const LoaderComp = () => (
  <div className="loading-comp">
    <ImgIconComp id="loadinggif" />
  </div>
)

export default LoaderComp;
